import { render, staticRenderFns } from "./All-companies.vue?vue&type=template&id=3a91ba1e&scoped=true&"
import script from "./All-companies.vue?vue&type=script&lang=js&"
export * from "./All-companies.vue?vue&type=script&lang=js&"
import style0 from "./All-companies.vue?vue&type=style&index=0&id=3a91ba1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a91ba1e",
  null
  
)

export default component.exports